import {
  CMSApiBase,
  CMSDescription,
  CMSFaq,
  CMSHowToParticipate,
  CMSImageBase,
  createCmsUrl,
  getResponseCMS,
} from './base';
import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';

export interface BonanzaPromoImageByStatus {
  promoStatus: string;
  image: CMSImageBase;
}

export interface BonanzaPromoMenuDataApi extends CMSApiBase {
  menu: {
    bg: CMSImageBase;
    unloggedCharacter: CMSImageBase;
    returnToStartFresh: string;
    claimBonus: string;
    yourProgress: string;
    yourReward: string;
    charactersByStatus: BonanzaPromoImageByStatus[];
  };
  pageTitle: string;
}

export const getBonanzaPromoMenuCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'bonanza-promo',
    queryData: {
      ...getCMSLocale(lang),
      populate: {
        menu: {
          populate: {
            bg: true,
            unlogged_character: true,
            characters_by_status: {
              populate: {
                image: true,
              },
            },
          },
        },
      },
    },
  });

export const getBonanzaPromoCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'bonanza-promo',
    queryData: {
      ...getCMSLocale(lang),
      populate: 'deep',
    },
  });

export const getBonanzaPromoPageTitleCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'bonanza-promo',
    queryData: {
      ...getCMSLocale(lang),
      fields: ['page_title'],
    },
  });

export const fetchBonanzaPromoMenuCMS = async (lang: string) => {
  const response = await fetcherCMS<BonanzaPromoMenuDataApi>(
    getBonanzaPromoMenuCMSUrl(lang)
  );
  return { data: response };
};

export interface BonanzaPromoDataApi extends BonanzaPromoMenuDataApi {
  bg: CMSImageBase;
  titleImg: CMSImageBase;
  description: string;
  congratulations: string;
  enjoyYourPlay: string;
  bonanzaStatus: BonanzaPromoImageByStatus[];
  howToParticipateTitle: string;
  howToParticipate: CMSHowToParticipate[];
  faq: CMSFaq[];
  titleV2: CMSDescription[];
  descriptionV2: CMSDescription[];
}

export const fetchBonanzaPromo = async (lang: string) => {
  const response = await fetcherCMS<BonanzaPromoDataApi>(
    getBonanzaPromoCMSUrl(lang)
  );
  return { data: response };
};

export interface BonanzaPromoPageTitleApi extends CMSApiBase {
  pageTitle: string;
}

export const fetchBonanzaPromoPageTitleCMS = async (lang: string) => {
  const response = await fetcherCMS<BonanzaPromoPageTitleApi>(
    getBonanzaPromoPageTitleCMSUrl(lang)
  );
  return { data: response };
};
